import AxiosInstance from "../Utils/axios/axiosConfig";

export const getJobCards = async () => {
  const response = await AxiosInstance.get("/jobcards/");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getJobCardsInfo = async (params, state) => {
  let response;
  if (!params) {
    response = await AxiosInstance.get("/jobcards-info/");
    return response.data.data;
  }
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  if (state) {
    response = await AxiosInstance.get(
      `/jobcards-info/?state=${state}&start=${start}&end=${end}`
    );
  } else {
    response = await AxiosInstance.get(
      `/jobcards-info/?start=${start}&end=${end}`
    );
  }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getJobCardsDetails = async (body) => {
  const response = await AxiosInstance.post("/jobcards/?get", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getJobCardsDetailsMultistage = async (body) => {
  const response = await AxiosInstance.post("/jobcards/multistage/?get", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFailedGroups = async (body) => {
  const response = await AxiosInstance.post("/failed-groups/?get", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getJobCardsById = async (id = "") => {
  const response = await AxiosInstance.get("/jobcards/", {
    params: {
      id,
    },
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};
export const getJobCardsByIdMultistage = async (id = "") => {
  const response = await AxiosInstance.get("/jobcards/multistage/", {
    params: {
      id,
    },
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};


export const getMultiStageJobCardsById = async (id = "") => {
  const response = await AxiosInstance.get(`jobcards/multistage/?id=${id}`
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteJobCard = async (id) => {
  const response = await AxiosInstance.delete("/jobcards/", {
    params: {
      id,
    },
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const postGroups = async (body) => {
  const response = await AxiosInstance.post("/jobcards/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const postGroupsMultistage = async (body) => {
  const response = await AxiosInstance.post("/jobcards/multistage/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const postSheetGroups = async (body) => {
  const response = await AxiosInstance.post("/jobcards-2d/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const postDuplexGroups = async (body) => {
  const response = await AxiosInstance.post("/jobcards-2d/duplex/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getAlgorithmCompletionStatus = async () => {
  const response = await AxiosInstance.get("jobcards/?ready");
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getAlgorithmCompletionStatusMultiStage = async () => {
  const response = await AxiosInstance.get("jobcards/multistage/?ready");
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getJobCardCylinders = async (id, width) => {
  const response = await AxiosInstance.post("/jobcard-cylinders/", {
    id: id,
    width: width,
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const getMultiStageJobCardCylinders = async (id, width) => {
  const response = await AxiosInstance.post("/jobcard-cylinders/multistage/", {
    id: id,
    width: width,
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const putSolutionStatus = async (id, solution, status) => {
  // console.log('solution in status:',solution);
  const response = await AxiosInstance.put("/jobcards/", {
    jobcard_id: id,
    solution: solution,
    status: status,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};
export const unselectGrpOfAcceptedJobcards = async (body) => {
  const response = await AxiosInstance.delete("/jobcards/machine-selection/?bulk", {
    data: body,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const putSolutionStatusMultistage = async (id, solution, status) => {
  // console.log('solution in status:',solution);
  const response = await AxiosInstance.put("/jobcards/multistage/", {
    jobcard_id: id,
    solution: solution,
    status: status,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const putSheetSolutionStatus = async (id, solution, status) => {
  // console.log('solution in status:',solution);
  const response = await AxiosInstance.put("/jobcards-2d/", {
    jobcard_id: id,
    solution: solution,
    status: status,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const putDuplexSolutionStatus = async (id, solution, status) => {
  // console.log('solution in status:',solution);
  const response = await AxiosInstance.put("/jobcards-2d/duplex/", {
    jobcard_id: id,
    solution: solution,
    status: status,
  });
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getShortJobCardCylinders = async (id, width) => {
  const response = await AxiosInstance.post("/short-jobcard-cylinders/", {
    id: id,
    width: width,
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};
export const getShortJobCardCylindersMultistage = async (id, width, solution) => {
  const response = await AxiosInstance.post("/short-jobcard-cylinders/multistage/", {
    id: id,
    width: width,
    solution: solution,
  });
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};
export const approveRejectJobCard = async (body = {}) => {
  const response = await AxiosInstance.put("/approve-reject-jobcards/", body);
  return response.data;
};

// Search Deckle-match order list
export const searchDeckleMatchOrders = async (
  pattern = "",
  source = undefined,
  orderState,
  PageParams,
  sortParams,
  orderData = "",
  paginationParam,
) => {
  let response;
  if (source) {
    if (orderState !== "incomplete_orders") {
      response = await AxiosInstance.get(
        "/deckle-match-order-details/?search",
        {
          params: {
            type: "contains",
            pattern: pattern,
            sort_by: sortParams?.sort_by,
            sort_type: sortParams?.sort_type,
            order_type: orderState,
            ord_type: orderData,
            start: PageParams?.start,
            end: PageParams?.end,
          },
        }
      );
    } else {
      response = await AxiosInstance.get(
        "/deckle-match-order-details/?search",
        {
          params: {
            type: "contains",
            pattern: pattern,
            sort_by: sortParams?.sort_by,
            sort_type: sortParams?.sort_type,
            order_type: orderState,
            ord_type: orderData,
            start: PageParams.start,
            end: PageParams.end,
          },
          cancelToken: source?.token,
        }
      );
    }
  } else {
    const startParam = (paginationParam.page - 1) * paginationParam.size;
    const endParam = startParam + paginationParam.size * 1;
    if (orderState === "incomplete_orders" && orderData) {
      response = await AxiosInstance.get(
        "/deckle-match-order-details/?search",
        {
          params: {
            type: "contains",
            pattern: pattern,
            sort_by: sortParams?.sort_by,
            sort_type: sortParams?.sort_type,
            order_type: orderState,
            ord_type: orderData,
            start: startParam,
            end: endParam
          },
        }
      );
    } else {
      response = await AxiosInstance.get(
        "/deckle-match-order-details/?search",
        {
          params: {
            type: "contains",
            pattern: pattern,
            sort_by: sortParams?.sort_by,
            sort_type: sortParams?.sort_type,
            order_type: orderState,
            ord_type: orderData,
            start: startParam,
            end: endParam
          },
        }
      );
    }
  }
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFilteredJobcards = async (params, filter, state, searchedValue = "") => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  const response = state
    ? await AxiosInstance.post(
      `/jobcards/filter/?state=${state}&start=${start}&end=${end}${searchedValue ? `&search&type=contains&pattern=${searchedValue}` : ""}`,
      filter
    )
    : await AxiosInstance.post(
      `/jobcards/filter/?start=${start}&end=${end}${searchedValue ? `&search&type=contains&pattern=${searchedValue}` : ""}`,
      filter
    );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getImageURL = async (body) => {
  const response = await AxiosInstance.post("/generate-signed-url/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    throw response;
  }
};

export const getBulkURL = async (body) => {
  const response = await AxiosInstance.post("/generate-signed-url/?bulk", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    throw response;
  }
};


export const searchDeckleMatchGroups = async (pattern = "") => {
  const response = await AxiosInstance.get(
    "/jobcards/machine-selection/?search",
    {
      params: {
        type: "contains",
        pattern: pattern,
      },
    }
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};
export const getValidMergeGroups = async (body) => {
  const response = await AxiosInstance.post(
    "/jobcards/machine-selection/merge-groups/?get&only_grade_quality",
    body
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const mergeGroups = async (body, isAutoMerge) => {
  const queryParam = isAutoMerge ? "?edit" : "";
  const response = await AxiosInstance.post(
    `/jobcards/machine-selection/merge-groups/${queryParam}`,
    body
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const seperateGroups = async () => {
  const response = await AxiosInstance.put(
    "/jobcards/machine-selection/merge-groups/?remove"
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const deleteGroup = async (id) => {
  const response = await AxiosInstance.delete(
    `/jobcards/machine-selection/?id=${id}`
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const cancelJobCard = async () => {
  const response = await AxiosInstance.put("/jobcards/cancel/");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const createNewSolution = async (body) => {
  const response = await AxiosInstance.post("/jobcards/new-solution/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const readyJobCardSinglestageNewSolution = async () => {
  const response = await AxiosInstance.get("/jobcards/new-solution/?ready");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const createNewSolutionMultistage = async (body) => {
  const response = await AxiosInstance.post("jobcards/new-solution/multistage/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};
export const readyJobCardMultistageNewSolution = async () => {
  const response = await AxiosInstance.get("/jobcards/new-solution/multistage/?ready");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const createNewSheetSolution = async (body) => {
  const response = await AxiosInstance.post("/jobcards/new-solution-2d/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const createNewDuplexSolution = async (body) => {
  const response = await AxiosInstance.post(
    "/jobcards/new-solution-2d/duplex/",
    body
  );
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const searchJobCardByJobcardNo = async (id) => {
  const response = await AxiosInstance.get(
    `/jobcards-info/?search&pattern=${id}`
  );
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getDeckleFormats = async () => {
  const response = await AxiosInstance.get("export/default/");
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const saveDefaultSelectionForJobCardPrint = async (body) => {
  const response = await AxiosInstance.put("export/default/", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getQualitySelectedOrders = async (body, params, type, source = undefined) => {
  let response;
  if (source) {
    if (params) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.post(
        `/jobcards/orders-selection/quality/?order_type=${type}&start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}`,
        body, { cancelToken: source.token }
      );
    }
  }
  else {
    if (params) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.post(
        `/jobcards/orders-selection/quality/?order_type=${type}&start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}`,
        body
      );
    }
  }

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const searchQualitySelectedOrders = async (
  pattern = "",
  code = "",
  body, params
) => {
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  let response;
  response = await AxiosInstance.post(`/jobcards/orders-selection/?search&type=contains&pattern=${pattern}&start=${start}&end=${end}`, body)
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};

export const getFilteredQualitySelectedOrders = async (
  sort,
  filter,
  source = undefined
) => {
  if (sort) {
    const start = (sort.page - 1) * sort.size;
    const end = start + sort.size * 1;
    const response = await AxiosInstance.post(
      `/orders/filter/?quality_orders&sort_by=${sort.sort_by}&sort_type=${sort.sort_type}&start=${start}&end=${end}`,
      filter
    );
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  }
};

export const getQualitySelectedOrdersForMultiStage = async (body, params, type, source = undefined) => {
  let response;
  if (source) {
    if (params) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.post(
        `/jobcards/multistage/orders-selection/quality/?order_type=${type}&start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}`,
        body,
        { cancelToken: source.token }
      );
    }
  }
  else {
    if (params) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      response = await AxiosInstance.post(
        `/jobcards/multistage/orders-selection/quality/?order_type=${type}&start=${start}&end=${end}&sort_by=${params.sort_by}&sort_type=${params.sort_type}`,
        body
      );
    }
  }

  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};


export const getIntermediateList = async (orders, jobcard, solution) => {
  const interParams = {
    orders: orders,
    jobcard: jobcard,
    solution: solution,
  };
  const response = await AxiosInstance.post(
    `deckle-match-order-details/?intermediate_reels`,
    interParams
  );
  if (!response.data.error) {
    return response.data.data;
  }
}
export const saveBulkDeckleOrders = async (body) => {
  const response = await AxiosInstance.put("/deckle-match-order-details/?bulk", body);
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};
export const editCoreIdForOrderSummary = async (body) => {
  const res = await AxiosInstance.put(
    "/jobcards/machine-selection/quality/",
    body
  );
  if (!res.data.error) {
    return res;
  } else {
    return Promise.reject(res);
  }
};
export const editToleranceForOrderSummary = async (body) => {
  const res = await AxiosInstance.put(
    "/jobcards/machine-selection/order-tolerance/",
    body
  );
  if (!res.data.error) {
    return res;
  } else {
    return Promise.reject(res);
  }
};

export const paperMachineQualityOrderSelection = async (body) => {
  const response = await AxiosInstance.post("/jobcards/machine-selection/quality/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const paperMachineQualityOrderSelectionMultiStage = async (body) => {
  const response = await AxiosInstance.post("/jobcards/multistage/machine-selection/quality/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const paperMachinePurchaseOrderSelection = async (body) => {
  const response = await AxiosInstance.post("/jobcards/machine-selection/orders/", body);
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};

export const editJobCardReelOD = async (body) => {
  const response = await AxiosInstance.put("/jobcards/machine-selection/quality/?orders&bulk", body);
  if (!response.data.error)
    return response.data;
  else
    return Promise.reject(response);
}

export const getAllJobCards = async (params, pattern, filter) => {
  let response;
  if (!params) {
    response = await AxiosInstance.post("/jobcards-info/&general");
    return response.data.data;
  }
  const start = (params.page - 1) * params.size;
  const end = start + params.size * 1;
  if (!pattern && !filter.length) {
    response = await AxiosInstance.get(
      `/jobcards-info/?start=${start}&end=${end}&general`,
      filter
    );
  } else
    if (pattern) {
      response = await AxiosInstance.post(
        `/jobcards/filter/?start=${start}&end=${end}&search&type=contains&pattern=${pattern}&general`,
        filter
      );
    } else {
      response = await AxiosInstance.post(
        `/jobcards/filter/?start=${start}&end=${end}&general`,
        filter
      );
    }
  if (!response.data.error) {
    return response.data.data;
  } else {
    return Promise.reject(response);
  }
};


export const downloadJobcardsExcel = async (jobcardIds, reportType) => {
  try {
    const response = await AxiosInstance.post(
      "/jobcards/export/excel/",
      {
        jobcard_ids: jobcardIds,
        report_type: reportType,
      },
      {
        responseType: "blob", // important: ensures binary data
      }
    );

    // Create a blob from the response
    const blob = new Blob([response.data], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const date = new Date();

    const day = String(date.getDate()).padStart(2, "0"); // 01 → 31
    const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase(); // JAN, FEB, AUG

    let fileName = `Deckle_Report-${day}-${month}.xlsx`;

    // Create a link element and click it to trigger download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

  } catch (error) {
    console.error("Error downloading Excel:", error);
  }
};
export const getAlgorithmCompletionStatusOfSimplexNewSol = async () => {
  const response = await AxiosInstance.get("jobcards/new-solution-2d/?ready");
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};
export const getAlgorithmCompletionStatusOfDuplexNewSol = async () => {
  const response = await AxiosInstance.get("jobcards/new-solution-2d/duplex/?ready");
  if (!response.data.error) {
    return response.data;
  } else {
    return Promise.reject(response);
  }
};